<template>
  <div id="chart">
    <apexchart type="radialBar" height="400" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts"
import { getCaecirsCounts, topTenCaeCirs, sumCaecirs } from "../databaseRequests"
import { mixPalette } from "../generalFunctions"

// percentage definition
var categoriesData = getCaecirsCounts()
var categoriesNames = topTenCaeCirs

export default {
  name: "RadialCaeCirs",
  components: {
    apexchart: VueApexCharts
  },
  data: function() {
    return {
      series: categoriesData,
      chartOptions: {
        colors: mixPalette,
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                fontSize: "15px"
              },
              value: {
                fontSize: "16px"
              },
              total: {
                show: true,
                label: "Total",
                formatter: function(w) {
                  // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                  return sumCaecirs
                }
              }
            }
          }
        },
        labels: categoriesNames
      }
    }
  }
}
</script>

<style scoped></style>
